import { render, staticRenderFns } from "./ViewStatements.vue?vue&type=template&id=184c9476"
import script from "./ViewStatements.vue?vue&type=script&lang=js"
export * from "./ViewStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports